// src/pages/tabs/OverviewTab.jsx
import ChartCard from "../../components/ui/ChartCard";
import "../../components/sections/DashboardCharts.css";

export default function OverviewTab({ data, mode = "abs" }) {
  const metrics = data?.algemeenMetrics || {};
  const safePerYear = Array.isArray(metrics.per_year) ? metrics.per_year : [];
  const categories_year = safePerYear.map((item) => item.year);
  const absValues = safePerYear.map((item) => Number(item?.count) || 0);
  const relValues = safePerYear.map((item) => Number(item?.count_rel) || 0);

  const perYearSeries = [
    {
      name: "Aantal vragenlijsten",
      data: mode === "rel" ? relValues : absValues,
    },
  ];

  const perYearOptions = {
    chart: { toolbar: { show: false } },
    xaxis: { categories: categories_year },
    plotOptions: { bar: { borderRadius: 4 } },
    colors: ["#7E22CE"],
    dataLabels: {
      enabled: true,
      formatter: (val) => (mode === "rel" ? `${Number(val).toFixed(1)}%` : `${val}`),
    },
    tooltip: {
      y: {
        formatter: (val, opts) => {
          const idx = opts?.dataPointIndex ?? 0;
          const abs = absValues[idx] ?? 0;
          const rel = relValues[idx] ?? 0;
          return `${abs} (${rel}%)`;
        },
      },
    },
  };

  const counts = metrics.counts || null;
  const absDonutSeries = counts
    ? [counts.Jongere, counts.Ouder_verzorger]
    : [0, 0];
  const donutTotal = counts?.Totaal ?? absDonutSeries.reduce((sum, value) => sum + (Number(value) || 0), 0);
  const relDonutSeries = counts
    ? [counts.Jongere_rel, counts.Ouder_verzorger_rel].map((value) => Number(value) || 0)
    : [0, 0];
  const donutSeries = mode === "rel" ? relDonutSeries : absDonutSeries;

  const donutOptions = {
    chart: { type: "donut" },
    labels: ["Jeugdigen", "Ouders/Verzorgers"],
    colors: ["#7E22CE", "#3B82F6"],
    plotOptions: {
      pie: {
        donut: {
          size: "60%",
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: "14px",
              fontWeight: 600,
              color: "#374151",
              offsetY: 16,
            },
            value: {
              show: true,
              fontSize: "20px",
              fontWeight: 700,
              color: "#111827",
              offsetY: -16,
              formatter: (val) =>
                mode === "rel" ? `${Number(val).toFixed(1)}%` : `${val}`,
            },
            total: {
              show: true,
              label: "Totaal",
              color: "#6B7280",
              fontSize: "14px",
              fontWeight: 500,
              formatter: () => donutTotal,
            },
          },
        },
      },
    },
    dataLabels: {
      enabled: true,
      style: { fontSize: "12px", fontWeight: 600, colors: ["#fff"] },
      dropShadow: { enabled: false },
      formatter: (val, opts) => {
        const idx = opts?.seriesIndex ?? 0;
        const abs = absDonutSeries[idx] ?? 0;
        const rel = relDonutSeries[idx] ?? 0;
        if (mode === "rel") {
          return `${rel}%`;
        }
        return `${abs}`;
      },
    },
    legend: {
      position: "bottom",
      horizontalAlign: "center",
      fontSize: "13px",
      fontWeight: 500,
      labels: { colors: "#374151" },
    },
    stroke: {
      width: 4,
      colors: ["#fff"],
      lineCap: "round",
    },
    tooltip: {
      y: {
        formatter: (val, opts) => {
          const idx = opts?.seriesIndex ?? 0;
          const abs = absDonutSeries[idx] ?? 0;
          const rel = relDonutSeries[idx] ?? 0;
          return `${abs} (${rel}%)`;
        },
      },
    },
  };

  return (
    <div>
      <div className="row row-2">
        <ChartCard
          title="Vragenlijsten per jaar"
          options={perYearOptions}
          series={perYearSeries}
          type="bar"
          info="Het aantal ingevulde vragenlijsten per jaar."
        />
        <ChartCard
          title="Verdeling jeugd vs. ouders/verzorgers"
          options={donutOptions}
          series={donutSeries}
          type="donut"
          info="Ik ben een jongere of ouder/verzorger"
        />
      </div>
    </div>
    
  );
}
